<template>
    <div>
        <div class="grid grid--max-width" style="position: relative; direction: ltr;" v-show="showPassTypeFilter || showPerkTypeFilter">
            <div class="attraction-filters-wrapper grid grid--max-width">
                <div class="flex-container align-middle align-center">
                    <section id="attractions-section" style="flex: 1 1 100%;">

                        <div class="attractions-overview-app">

                            <div class="filter-container" v-show="showPassTypeFilter">
                                <div class="js-simple-dropdown">
                                    <button type="button" aria-expanded="false" aria-controls="modalPassTypes" id="passTypesButton" class="filter-select rectangle">
                                        <span>{{ getPassTypeFilterText }}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 20" width="32" height="20" aria-hidden="true" focusable="false">
                                            <path d="M16 12.318L27.333.796c1.043-1.061 2.735-1.061 3.778 0 1.043 1.061 1.043 2.78 0 3.841L16 20 .888 4.637C-.155 3.576-.155 1.857.888.796c1.043-1.061 2.735-1.061 3.778 0L16 12.318z"></path>
                                        </svg>
                                    </button>

                                    <div class="modal modal-filter-type simple-dropdown" id="modalPassTypes" aria-labelledby="passTypesButton">
                                        <div class="modal-dropdown modal-dropdown-filter-type">
                                            <ul>
                                                <li v-for="(passType, index) in passTypes" :key="index">
                                                    <div>
                                                        <label>
                                                            <input type="checkbox" v-model="passType.selected" v-on:change="getfilteredData" />
                                                            <span>
                                                                {{ passType.name }}
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" width="18" height="15" aria-hidden="true" focusable="false"><path fill="#000" d="M16 0l1.43 1.4L4.98 14.13 0 9.037l1.43-1.398 3.55 3.63z"></path></svg>
                                                            </span>
                                                        </label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <!-- check boxes -->
                            <div class="filter-container icon-filter-container" id="checkboxes" v-show="showPerkTypeFilter">

                                <label class="form-check-label icon-filter checkbox-filter" v-bind:class="{ active: perk.Selected }" v-for="(perk,index) in perkTypes" :key="index">
                                    <input class="form-check-input" type="checkbox" :id="perk.name.replace(/\s/g, '')" v-model="perk.selected" v-on:change="getfilteredData">
                                    <span v-html="perk.rawSvg"></span>
                                    <div class="icon-text">{{ perk.name }}</div>
                                </label>

                            </div>


                            <!-- end of checkboxes -->



                        </div>

                    </section>
                </div>
            </div>
        </div>
        <section class="pass-types-wrapper" data-vertical-space-small>
            <div v-if="loading" style="width:100%;">Loading data...</div>
            <div class="pass-types">
                <!-- iterate data -->
                <perk-item-card v-for="(item, index) in filteredData" :key="index" :item="item" :passTypes="passTypes" :perkTypes="perkTypes"></perk-item-card>
            </div>

            <div class="u-text-center" style="width:100%;" v-if="filteredData.length===0">NO RESULTS!</div>
        </section>
    </div>







</template>
<script>
    import axios from 'axios';
    import PerkItemCard from './PerkItemCard';

    const siteConfig = {};
    Object.assign(siteConfig, window.merlinConfig);
    export default {
        name: 'Perks',
        components: {
            'perk-item-card': PerkItemCard
        },
        props: {
            passTypeDefaultFilterText: String,
            displayPassTypeFilter: Boolean,
            displayPerkTypeFilter: Boolean
        },
        data() {
            return {
                showPassTypeFilter: this.displayPassTypeFilter,
                showPerkTypeFilter: this.displayPerkTypeFilter,
                passTypeFilterText: this.passTypeDefaultFilterText,
                filteredData: [],
                search: '',
                perkTypes: [],
                lazyLoadedData: [],
                passTypes: [],
                loading: true,
                errored: false
            };
        },
        methods: {
            getfilteredData: function () {
                //console.log("getfilteredData");

                this.filteredData = this.lazyLoadedData;
                let filteredDataByfilters = [];

                //SORTING BY PASSTYPES

                if (this.selectedPassTypes.length > 0) {

                    //console.log("Sorting for passtypes...");

                    filteredDataByfilters = [];

                    this.filteredData.forEach((d) => {
                        //console.log(d);
                        const x = this.selectedPassTypes;
                        const y = Array.from(d.passTypes);
                        const z = x.some(v => y.includes(v));

                        if (z) {
                            filteredDataByfilters.push(d)
                        }
                    });

                    //this.filteredData = filteredDataByfilters.length > 0 ? filteredDataByfilters : this.lazyLoadedData;
                    this.filteredData = filteredDataByfilters;

                    //console.log("DONE!");
                    //console.log("Result so far is ", this.filteredData);
                }


                //SORTING BY PERKS
                if (this.selectedPerks.length > 0) {

                    //console.log("Sorting for perks...");

                    filteredDataByfilters = [];

                    this.filteredData.forEach((d) => {
                        //console.log(d);
                        const x = this.selectedPerks;
                        const y = Array.from(d.perkTypes);
                        const z = x.some(v => y.includes(v));

                        if (z) {
                            filteredDataByfilters.push(d)
                        }
                    });

                    //this.filteredData = filteredDataByfilters.length > 0 ? filteredDataByfilters : this.lazyLoadedData;
                    this.filteredData = filteredDataByfilters;

                    //console.log("DONE!");
                    //console.log("Result so far is ", this.filteredData);

                }

                //console.log("Final result is: ", this.filteredData);


            }
        },
        mounted() {

            axios
                //.get('https://assets.codepen.io/19711/filterdata.json')
                .get(`${siteConfig.urlPrefix}/umbraco/api/MapFiltering/getallperks`)
                .then(response => {
                    this.lazyLoadedData = response.data.perks;
                    this.perkTypes = response.data.perkTypes;
                    this.passTypes = response.data.passTypes;
                })
                .catch(error => {
                    console.log(error)
                    this.errored = true;
                })
                .finally(() => {
                    this.loading = false;
                    
                    const hash = window.location.hash;

                    if (hash && hash !== "") {
                        const name = hash.replace('#', '').replace(' ', '').replace('%20', '').replace('+', '');
                        const found = this.perkTypes.find(element => element.name.replace(/\s/g, '').toLowerCase() === name.toLowerCase());

                        if (found && found !== undefined && found !== null) {
                            found.selected = true;

                            const checkbox = document.querySelector(name);
                            if (checkbox !== null) {
                                //create fake element and trigger click to scroll down
                                const a = document.createElement("a");
                                a.setAttribute("href", name);
                                a.click();
                            }

                        }
                    }

                    this.getfilteredData();

                })

        },
        computed: {
            selectedPerks: function () {
                let filters1 = [];
                let checkedPerks = this.perkTypes.filter(obj => obj.selected);
                checkedPerks.forEach(element => {
                    filters1.push(element.id);
                });
                //console.log(filters1);
                return filters1;
            },
            selectedPerksNames: function () {
                let filters1 = [];
                let checkedPerks = this.perkTypes.filter(obj => obj.selected);
                checkedPerks.forEach(element => {
                    filters1.push(element.name);
                });
                //console.log(filters1);
                return filters1;
            },

            selectedPassTypes: function () {
                let filters2 = [];
                let checkedPassTypes = this.passTypes.filter(obj => obj.selected);
                checkedPassTypes.forEach(element => {
                    filters2.push(element.id);
                });
                //console.log(filters2);
                return filters2;
            },

            selectedPassTypeNames: function () {
                let filters3 = [];
                let checkedPassTypes = this.passTypes.filter(obj => obj.selected);
                checkedPassTypes.forEach(element => {
                    filters3.push(element.name);
                });
                //console.log(filters3);
                return filters3;
            },
            getPassTypeFilterText: function () {
                return this.selectedPassTypes.length > 0 ? this.selectedPassTypeNames.join(", ") : this.passTypeFilterText;
            }
        }
    };
</script>